import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy } from '@angular/core';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import * as fromUser from '@app/core/user/store/reducers';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export const SKIP_LINKS = [
  '#main-content',
  '#main-navigation',
  '#headerSearch',
  '#footer',
  '#user-access',
  '#user-login'
];

@Component({
  selector: 'vc-skip-links',
  templateUrl: './skip-links.component.html',
  styleUrls: ['./skip-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkipLinksComponent implements OnInit, OnDestroy {
  @Input()
  skipLinkPath: string;

  links = SKIP_LINKS;

  isLogged: boolean;

  private ngUnsubscribe = new Subject<void>();

  constructor(private store: Store<IAppState>) {}

  ngOnInit(): void {
    this.store.pipe(select(fromUser.isAuthenticated), takeUntil(this.ngUnsubscribe)).subscribe(
      res => {
        this.isLogged = res;
      },
      err => {
        console.error(err);
      }
    );
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
